export default __webpack_public_path__ + "static/media/default-document.1fcb0e2c.jpg";